import { styled } from '@mui/material/styles'

export const MainWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,

  '& .MuiDataGrid-root': {
    fontSize: '0.875rem',
  },
})

export const ToolBarWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '10px 0px',
})

export const LeftToolBarWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
})

export const RightToolBarWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
})

// TODO:
export const DataGridWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'bgColor',
})<{ bgColor?: string }>(({ bgColor, theme }) => ({
  display: 'flex',
  flex: 1,
  // width: '98%',
  // height: '100%',
  backgroundColor: bgColor ?? 'transparent',
  paddingBottom: '12px',

  '& .MuiDataGrid-columnHeaders': {
    borderBottom: `2px solid ${theme.palette.grey[300]}`,
  },

  '& .MuiDataGrid-virtualScrollerContent': {
    borderTop: `2px solid ${theme.palette.grey[300]}`,
    backgroundColor: theme.legacyColors.BLACK_040,
  },

  '& .MuiDataGrid-row': {
    background: theme.palette.common.white,
    borderRight: '1px solid transparent',
    width: '99.7%',

    ':nth-of-type(even)': {
      backgroundColor: theme.palette.background.popup.paper,
      border: `1px solid ${theme.legacyColors.GREY_TABLE}`,
    },

    '& .MuiDataGrid-cell': {
      border: 'none',
    },
  },
  '& .MuiTablePagination-root': {
    overflowX: 'hidden!important',
  },
}))
